<template>
  <div  class="content-wrapper">
    <div class="ibox-title">
        <h5>职工体检导入</h5>
    </div>
    <el-form label-width="140px" label-position="right" class="demo-dynamic">
      <el-form-item label="模板文件下载：">
        <el-button type="text" @click="modelDownload()">职工体检信息导入模板.xls</el-button>
        <p class="redtip">（提示：导入的信息必须符合模板文件的要求。）</p>
      </el-form-item>
    </el-form>
    <div>
      <label class="el-form-item__label" style="width: 140px;">
        <label class="redtip" style="left:-5px">*</label>上传导入文件：</label>
      <el-input style="width:180px" size="small" :readonly="true" placeholder="请选择文件" v-model="fileName"></el-input>
      <el-upload class="upload-demo" 
      	ref="upload" 
      	:action="importUrl" 
      	:data="importData" 
        name="UpLoadFile"
      	:multiple="true" 
      	:auto-upload="false" 
      	:on-error="uploadError" 
      	:on-success="uploadSuccess" 
      	:show-file-list="false" 
      	:on-change="handleChange" 
        :headers="token"
      	accept=".xls">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">导入</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
export default {
  data () {
    return {
      fileName: '',
      importUrl: config.host + 'mecImport/importMecInfoForStaff.do',
      importData: {
        importID: 'AOrgFoodImport',
        colsNum: 31,
        headRowsNum: 2
      },
      token: {
        'Haiziguo-Token': localStorage.getItem('Haiziguo-Token')
      }
    }
  },
  components: {

  },
  methods: {
    back () {
      this.$emit('close', false, true)
    },
    modelDownload () { // 下载模板
      location.href = config.host + 'mecExport/exportMECTempForStaff.do' + '?Haiziguo-Token=' + localStorage.getItem('Haiziguo-Token')
    },
    submitUpload () { // 导入按钮点击事件
      if (this.fileName.length > 0) {
        this.$refs.upload.submit()
      } else {
        return false
      }
    },
    handleChange (file) { // 导入文件改变事件
      this.fileName = file.name
    },
    uploadError (res) {
    },
    uploadSuccess (res) { // 导入成功
      if (res.success === true && res.list !== undefined) {
        this.openMsgBox(res.list)
      } else {
        var data = [res.msg]
        data.push.apply(data, res.body)
        if (res.success === true) { // 成功
          this.openMsgBox(data, true)
        } else {
          this.openMsgBox(data, true, false)
        }
      }
    },
    openMsgBox (data, msg, colse) { // 显示导入结果弹窗
      const h = this.$createElement
      const arr = []
      for (var i = 0; i < data.length; i++) {
        if (msg === true && i > 0) {
          data[i] = i + '.' + data[i]
          arr.push(h('p', { style: 'margin-top: 10px' }, data[i]))
        } else {
          arr.push(h('p', null, data[i]))
        }
      }
      this.$msgbox({
        title: '消息',
        customClass: 'importMsg',
        message: h('p', null, arr),
        showConfirmButton: false,
        beforeClose: (action, instance, done) => {
          if (action === 'cancel') {
            this.fileName = ''
            done()
          }
        },
        callback: (action, instance) => {
          if (colse !== false) {
            this.back()
          }
        }
      }).catch(() => {
      })
    }

  }
}
</script>

<style>
.el-form-item__content{
    width: auto;
}
.ml15 {
  margin-left: 15px;
}

.pt15 {
  padding: 15px 0;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}

.redtip {
  color: #ee4b31;
  position: relative;
  left: -120px;
}

input[type="file"] {
  display: none;
}

.upload-demo {
  display: inline-block;
}

#import_user .el-select {
  width: 345px;
}

#selssq .el-select {
  width: 112px;
}

#import_user .el-upload__input{
  display:none;
}

.el-message{
  padding:15px;
  min-width:50px;
}

.importMsg .el-message-box__content{
	max-height: 300px;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/physical/import.vue?14e17031